import { createAsyncAction } from 'typesafe-actions';

import {
  CommodityComplianceReport,
  CommodityMetrics,
  CommodityTransactionDetails,
  DebtQueryStatus,
  DownloadSponsorDashboardResponse,
  FXComplianceReport,
  FXMetrics,
  FXTransactionDetails,
  InstrumentAvailability,
  SponsorAlertsReport,
  SponsorComplianceReport,
  SponsorDashboardPricing,
  SponsorDashboardPricingHistory,
  SponsorFxExposureReport,
  SponsorPortfolioMetrics,
  SponsorProjectionReport,
  SponsorTransactionDetails,
} from './types';

export const getSponsorTopCardsData = createAsyncAction(
  'sponsor/getSponsorTopCardsData/request',
  'sponsor/getSponsorTopCardsData/success',
  'sponsor/getSponsorTopCardsData/failure',
)<undefined, SponsorPortfolioMetrics, undefined>();

export const getSponsorBenchmarkData = createAsyncAction(
  'sponsor/getSponsorBenchmarkData/request',
  'sponsor/getSponsorBenchmarkData/success',
  'sponsor/getSponsorBenchmarkData/failure',
)<undefined, SponsorProjectionReport, undefined>();

export const getSponsorCounterpartyData = createAsyncAction(
  'sponsor/getSponsorCounterpartyData/request',
  'sponsor/getSponsorCounterpartyData/success',
  'sponsor/getSponsorCounterpartyData/failure',
)<undefined, SponsorFxExposureReport, undefined>();

export const getSponsorFXCounterpartyData = createAsyncAction(
  'sponsor/getSponsorFXCounterpartyData/request',
  'sponsor/getSponsorFXCounterpartyData/success',
  'sponsor/getSponsorFXCounterpartyData/failure',
)<undefined, SponsorFxExposureReport, undefined>();

export const getSponsorComplianceData = createAsyncAction(
  'sponsor/getSponsorComplianceData/request',
  'sponsor/getSponsorComplianceData/success',
  'sponsor/getSponsorComplianceData/failure',
)<undefined, SponsorComplianceReport, undefined>();

export const getSponsorAlertsData = createAsyncAction(
  'sponsor/getSponsorAlertsData/request',
  'sponsor/getSponsorAlertsData/success',
  'sponsor/getSponsorAlertsData/failure',
)<undefined, SponsorAlertsReport, undefined>();

export const downloadSponsorDashboardReport = createAsyncAction(
  'sponsor/downloadSponsorDashboardReport/request',
  'sponsor/downloadSponsorDashboardReport/success',
  'sponsor/downloadSponsorDashboardReport/failure',
)<undefined, DownloadSponsorDashboardResponse, undefined>();

export const getSponsorTransactionDetailsData = createAsyncAction(
  'sponsor/getSponsorTransactionDetailsData/request',
  'sponsor/getSponsorTransactionDetailsData/success',
  'sponsor/getSponsorTransactionDetailsData/failure',
)<undefined, SponsorTransactionDetails, undefined>();

export const getSponsorFXMetricsData = createAsyncAction(
  'sponsor/getSponsorFXMetricsData/request',
  'sponsor/getSponsorFXMetricsData/success',
  'sponsor/getSponsorFXMetricsData/failure',
)<undefined, FXMetrics, undefined>();

export const getSponsorFXComplianceData = createAsyncAction(
  'sponsor/getSponsorFXComplianceData/request',
  'sponsor/getSponsorFXComplianceData/success',
  'sponsor/getSponsorFXComplianceData/failure',
)<undefined, FXComplianceReport, undefined>();

export const getSponsorFXTransactionDetailsData = createAsyncAction(
  'sponsor/getSponsorFXTransactionDetailsData/request',
  'sponsor/getSponsorFXTransactionDetailsData/success',
  'sponsor/getSponsorFXTransactionDetailsData/failure',
)<undefined, FXTransactionDetails, undefined>();

export const getSponsorCommodityMetricsData = createAsyncAction(
  'sponsor/getSponsorCommodityMetricsData/request',
  'sponsor/getSponsorCommodityMetricsData/success',
  'sponsor/getSponsorCommodityMetricsData/failure',
)<undefined, CommodityMetrics, undefined>();

export const getSponsorCommodityComplianceData = createAsyncAction(
  'sponsor/getSponsorCommodityComplianceData/request',
  'sponsor/getSponsorCommodityComplianceData/success',
  'sponsor/getSponsorCommodityComplianceData/failure',
)<undefined, CommodityComplianceReport, undefined>();

export const getSponsorCommodityTransactionDetailsData = createAsyncAction(
  'sponsor/getSponsorCommodityTransactionDetailsData/request',
  'sponsor/getSponsorCommodityTransactionDetailsData/success',
  'sponsor/getSponsorCommodityTransactionDetailsData/failure',
)<undefined, CommodityTransactionDetails, undefined>();

export const getSponsorPricingData = createAsyncAction(
  'sponsor/getSponsorPricingData/request',
  'sponsor/getSponsorPricingData/success',
  'sponsor/getSponsorPricingData/failure',
)<undefined, SponsorDashboardPricing, undefined>();

export const getSponsorPricingHistoryData = createAsyncAction(
  'sponsor/getSponsorPricingHistoryData/request',
  'sponsor/getSponsorPricingHistoryData/success',
  'sponsor/getSponsorPricingHistoryData/failure',
)<undefined, SponsorDashboardPricingHistory, undefined>();

export const getSponsorInstrumentAvailability = createAsyncAction(
  'sponsor/getSponsorInstrumentAvailability/request',
  'sponsor/getSponsorInstrumentAvailability/success',
  'sponsor/getSponsorInstrumentAvailability/failure',
)<undefined, InstrumentAvailability, undefined>();

export const getDebtQueryStatusAction = createAsyncAction(
  'sponsor/getDebtQueryStatus/request',
  'sponsor/getDebtQueryStatus/success',
  'sponsor/getDebtQueryStatus/failure',
)<undefined, DebtQueryStatus, undefined>();

export const submitDebtQueryAction = createAsyncAction(
  'sponsor/submitDebtQueryAction/request',
  'sponsor/submitDebtQueryAction/success',
  'sponsor/submitDebtQueryAction/failure',
)<undefined, DebtQueryStatus, undefined>();
